import { Tabs, Typography } from '@neo4j-ndl/react';
import { useAppSelector } from '@nx/state';
import { useCallback } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router';

import { fullPath } from './utils';

export type TabKey = 'usage' | 'invoices' | 'settings';
export const TabOptions: { label: string; key: TabKey }[] = [
  {
    key: 'usage',
    label: 'Current month usage',
  },
  {
    key: 'invoices',
    label: 'Invoices',
  },
  {
    key: 'settings',
    label: 'Payment Settings',
  },
];
const TabKeys = TabOptions.map(({ key: value }) => value);

const isTabKey = (key?: string): key is TabKey => Boolean(TabKeys.find((tabKey) => key === tabKey));

export function BillingLayout() {
  const navigate = useNavigate();
  const activeOrgId = useAppSelector(() => 'org123');

  const match = useMatch('/org/:orgId/billing/:activeTabKey');
  const activeTabKey = match?.params.activeTabKey;
  const selectedTab: TabKey = isTabKey(activeTabKey) ? activeTabKey : 'usage';

  const onTabChange = useCallback(
    (tabKey: TabKey) => {
      void navigate(fullPath(activeOrgId, tabKey));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [navigate],
  );

  return (
    <div className="h-full overflow-auto p-4">
      <Typography variant="h2" className="mb-6 px-2 pt-2">
        Billing
      </Typography>
      <div className="flex">
        <Tabs as="div" fill="underline" onChange={onTabChange} value={selectedTab}>
          {TabOptions.map((tabOption) => (
            <Tabs.Tab
              key={tabOption.key}
              tabId={tabOption.key}
              htmlAttributes={{
                'data-testid': tabOption.key,
              }}
            >
              {tabOption.label}
            </Tabs.Tab>
          ))}
        </Tabs>
      </div>
      <Outlet />
    </div>
  );
}
